import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { tampleteComapnyUnassignRoute } from '@features/enterprise/api/constants';
import { errorMessage } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { companiesListKey } from '../constants';

type useUnassignCompanyProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useUnassignCompany = ({
    setErrorText = () => { },
}: useUnassignCompanyProps) => {
    const client = useQueryClient();

    const { mutate: unassignCompany, isLoading: isUnassigningCompany } =
        useMutation({
            mutationFn: (variables: { company_id: string | number }) =>
                axiosInstance
                    .post(tampleteComapnyUnassignRoute, variables)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status !== 200) {
                    setErrorText(data.message);
                } else {
                    setErrorText('');
                    client.invalidateQueries([companiesListKey]);
                }
            },
            onError: () => setErrorText(errorMessage),
        });

    return {
        unassignCompany,
        isUnassigningCompany,
    };
};
